import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import AppsIcon from '@material-ui/icons/Apps';

// Route ref + title + icon put the page in the sidebar; Sidebar.tsx places it
// explicitly (`nav.take('page:platform-tools')`).
const rootRouteRef = createRouteRef();

/** Platform Tools: one page listing the platform's tools (agents, lookups). */
const platformToolsPage = PageBlueprint.make({
  params: {
    path: '/platform-tools',
    routeRef: rootRouteRef,
    title: 'Platform Tools',
    icon: <AppsIcon />,
    loader: () => import('./PlatformToolsPage').then(m => <m.PlatformToolsPage />),
  },
});

export const platformToolsPlugin = createFrontendPlugin({
  pluginId: 'platform-tools',
  title: 'Platform Tools',
  routes: { root: rootRouteRef },
  extensions: [platformToolsPage],
});
